import React from "react";
import { Button } from '@uhg-abyss/web/ui/Button';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';

export type MspLisQuizEarlyExitModal = {
  onCancelExitClicked: () => void;
  onConfirmExitClicked: () => void;
};

export function MspLisQuizEarlyExitModal({
  onCancelExitClicked,
  onConfirmExitClicked,
}): React.JSX.Element {
  return (
    <React.Fragment>
      <ModalDialog
        header="Are you sure you want to leave?"
        size="$md"
        isOpen={true}
        onClose={onCancelExitClicked}
      >
        <div>
          <Layout.Group
            alignLayout="center"
            style={{ marginTop: '12px', marginBottom: '9px' }}
          >
            <Text fontSize="md" fontWeight="medium">
              Your answers will not be saved.
            </Text>
          </Layout.Group>
        </div>
        <div>
          <Layout.Group
            alignLayout="center"
            style={{ paddingBottom: '19px' }}
          >
            <Grid align="center">
              <Grid.Col span={{ xs: 12, md: 6, lg: 6 }}>
                <Button
                  variant="outline"
                  style={{ width: '100%', marginRight: '6px' }}
                  onClick={onConfirmExitClicked}
                >
                  Yes, leave
                </Button>
              </Grid.Col>
              <Grid.Col span={{ xs: 12, md: 6, lg: 6 }}>
                <Button
                  type="submit"
                  style={{ width: '100%' }}
                  onClick={onCancelExitClicked}
                >
                  No, finish
                </Button>
              </Grid.Col>
            </Grid>
          </Layout.Group>
        </div>
      </ModalDialog>
    </React.Fragment>
  );
}
